import { FaPlus } from "react-icons/fa6";
import { Button, Card, CardBody, CardFooter, Container } from "reactstrap";
import { useTranslation } from "../../languages";
import { usePagination } from "../../utils";
import PaginationControls from "../specials/PaginationControls";

const Section = ({ title, items, Component, colClass }) => {
  const { t } = useTranslation();
  if (!items?.length) return null;

  return (
    <>
      <h5 className="f-5 mt-3 mb-3">{t(title)}</h5>
      <div className="row gy-3" style={{ "--bs-gutter-x": "1.3rem" }}>
        {items.map((item, index) => (
          <div key={index} className={colClass}>
            <Component details={item} />
          </div>
        ))}
      </div>
    </>
  );
};

const ItemsCard2 = ({
  firstItems,
  secondItems,
  thirdItems,
  fourthItems,
  ComponetForSecondItems,
  ComponentForFirstItems,
  onAddClick,
  canAddNew,
  user,
}) => {
  // ✅ Keep pagination config DRY
  const paginations = [
    usePagination(firstItems, 2),
    usePagination(secondItems, 4),
    usePagination(thirdItems, 4),
    usePagination(fourthItems, 4),
  ];

  const [
    [
      currentFirstItems,
      firstPages,
      firstPage,
      setFirstPage,
      nextFirst,
      prevFirst,
    ],
    [
      currentSecondItems,
      secondPages,
      secondPage,
      setSecondPage,
      nextSecond,
      prevSecond,
    ],
    [
      currentThirdItems,
      thirdPages,
      thirdPage,
      setThirdPage,
      nextThird,
      prevThird,
    ],
    [
      currentFourthItems,
      fourthPages,
      fourthPage,
      setFourthPage,
      nextFourth,
      prevFourth,
    ],
  ] = paginations;

  // ✅ Unified pagination state
  const maxPages = Math.max(
    firstPages.length,
    secondPages.length,
    thirdPages.length,
    fourthPages.length
  );
  const currentPage = Math.max(firstPage, secondPage, thirdPage, fourthPage);

  const setPage = (page) => {
    setFirstPage(page);
    setSecondPage(page);
    setThirdPage(page);
    setFourthPage(page);
  };

  return (
    <Card className="border-none" style={{ borderRadius: "15px" }}>
      <CardBody
        className="p-4 position-relative"
        style={{ overflowY: "scroll", height: "70vh" }}
      >
        <Container fluid className="p-0">
          {user?.roles[0] !== "contributor" && (
            <Section
              title="placesNearYou"
              items={currentFirstItems}
              Component={ComponentForFirstItems}
              colClass="col-md-6 col-xl-4"
            />
          )}

          <Section
            title="recent"
            items={currentFourthItems}
            Component={ComponetForSecondItems}
            colClass="col-md-6 col-lg-6 col-xl-3"
          />
          <Section
            title="mostPopular"
            items={currentThirdItems}
            Component={ComponetForSecondItems}
            colClass="col-md-6 col-lg-6 col-xl-3"
          />
          {user?.roles[0] === "contributor" && (
            <Section
              title="yourCommercials"
              items={currentSecondItems}
              Component={ComponetForSecondItems}
              colClass="col-md-6 col-lg-6 col-xl-3"
            />
          )}

          {canAddNew && (
            <Button
              onClick={onAddClick}
              className="bg-primary-blue p-0 position-sticky rounded-white-btn"
              style={{ "--radius": "77px", bottom: 30, left: "100%" }}
            >
              <FaPlus size={30} />
            </Button>
          )}
        </Container>
      </CardBody>

      <CardFooter className="bg-transparent py-3">
        <PaginationControls
          next={() => {
            nextFirst();
            nextSecond();
            nextThird();
            nextFourth();
          }}
          previous={() => {
            prevFirst();
            prevSecond();
            prevThird();
            prevFourth();
          }}
          pages={Array.from({ length: maxPages }, (_, i) => i + 1)}
          currentPageIndex={currentPage}
          setCurrentPageIndex={setPage}
        />
      </CardFooter>
    </Card>
  );
};

export default ItemsCard2;

/**equalizes the arrays */
const equalizeArrays = (firstItems, secondItems, thirdItems) => {
  let mostItems = Math.max(
    firstItems?.length,
    secondItems?.length,
    thirdItems?.length
  );
  let firstArrayExtraItems = mostItems - firstItems?.length;
  let secondArrayExtraItems = mostItems - secondItems?.length;
  let thirdArrayExtraItems = mostItems - thirdItems?.length;

  const selectRandomEntryFrom = (array) => {
    let randomIndex = Math.floor(Math.random() * array?.length);
    return array[randomIndex];
  };

  return {
    firstItems: [
      ...firstItems,
      ...Array.from({ length: firstArrayExtraItems }, (_) =>
        selectRandomEntryFrom(firstItems)
      ),
    ],
    secondItems: [
      ...secondItems,
      ...Array?.from({ length: secondArrayExtraItems }, (_) =>
        selectRandomEntryFrom(secondItems)
      ),
    ],
    thirdItems: [
      ...thirdItems,
      ...Array?.from({ length: thirdArrayExtraItems }, (_) =>
        selectRandomEntryFrom(thirdItems)
      ),
    ],
  };
};
